export default __webpack_public_path__ + "static/media/camera.bd3e4945.png";